import React, { useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import { CloseOutlined } from '@ant-design/icons';
import { Button, Col, Row, Select, Switch } from 'antd';

import ModalActions from 'components/ModalActions';
import { useNutror } from 'v2/hooks/useNutror';

interface IProps {
  isModal: boolean;
  open?: boolean;
  onClose?: any;
  onOk: any;
  nutror?: any;
}

const Nutror: React.FC<IProps> = ({ isModal, open, onClose, onOk, nutror }) => {
  const [directAccess, setDirectAccess] = useState(() => nutror && nutror.direct_access);
  const [selected, setSelected] = useState<any>('');
  const [inputSelected, setInputSelected] = useState<any>('');
  const prevPropsRef = useRef({ courses: [], packages: [], nutror });
  const { courses, packages } = useNutror();

  useEffect(() => {
    if (nutror && prevPropsRef.current.nutror !== nutror) {
      setSelected(nutror);
      setInputSelected(nutror.nutror_hash);
    }

    prevPropsRef.current = { courses, packages, nutror };
  }, [courses, packages, nutror]);

  const handleChange = useCallback(
    (hash: string) => {
      let newSelected: any;
      const selectedCourse = courses?.length && courses.filter(item => item.hash === hash)[0];
      const selectedPackage = packages?.length && packages.filter(item => item.hash === hash)[0];

      if (selectedCourse) {
        newSelected = selectedCourse;
        newSelected.nutror_id = selectedCourse.id;
        newSelected.type = 'C';
      } else if (selectedPackage) {
        newSelected = selectedPackage;
        newSelected.nutror_id = selectedPackage.id;
        newSelected.type = 'P';
      } else {
        toast.error('Ocorreu um erro ao tentar selecionar o curso ou pacote do nutror');
        return;
      }

      newSelected.nutror_hash = hash;
      newSelected.method_id = '24';
      newSelected.nutror_name = newSelected.title;
      setSelected(newSelected);
      setInputSelected(hash);
    },
    [courses, packages]
  );

  const handleOk = useCallback(() => {
    if (selected) {
      if (onOk) {
        if (nutror && selected.hash === nutror.hash && directAccess === nutror.direct_access) return onClose();
        selected.new = true;
        selected.direct_access = directAccess;
        onOk(selected, nutror);
        if (!nutror) toast.success(`Item ${selected.title} adicionado com sucesso!`);
        setSelected('');
        setInputSelected('');
      }
    } else {
      toast.warn('Por favor selecione um curso ou pacote');
    }
  }, [selected, directAccess, onOk, nutror, onClose]);

  const courseOptions = courses?.length
    ? courses.map(c => ({ label: c.title, value: c.hash }))
    : [{ label: 'Não há cursos cadastrados', value: '', disabled: true }];
  const packageOptions = packages?.length
    ? packages.map(p => ({ label: p.title, value: p.hash }))
    : [{ label: 'Não há pacotes cadastrados', value: '', disabled: true }];

  const content = (
    <form>
      <Row justify='center'>
        <Col span={24}>
          <label className='mb-1 block text-xs'>Selecione um curso ou pacote</label>
          <Select
            className='w-full'
            value={inputSelected || undefined}
            onChange={handleChange}
            options={[
              { label: 'Cursos', options: courseOptions },
              { label: 'Pacotes', options: packageOptions }
            ]}
          />
        </Col>
        <Col span={24} className='mt-4'>
          <label className='flex items-center gap-2'>
            <Switch checked={directAccess} onChange={checked => setDirectAccess(checked)} />
            Habilitar acesso direto na página de obrigado.
          </label>
        </Col>

        <Col span={24} className='mt-4'>
          <strong>Novo por aqui? Crie um curso no Nutror</strong>
          <p>
            O Nutror é nossa plataforma de membros, com ele você pode criar cursos e grupos de assinatura. Acesse o{' '}
            <a href='https://my.nutror.com/cursos' target='_blank' rel='noopener noreferrer'>
              link
            </a>{' '}
            para criar o curso!
          </p>
        </Col>
      </Row>
    </form>
  );

  return (
    <div>
      {isModal ? (
        <ModalActions buttonOk='Salvar' title='Entrega de Conteúdo' open={open} onClose={onClose} onOk={handleOk}>
          {content}
        </ModalActions>
      ) : (
        <div className='rounded-sm bg-white shadow-sm'>
          <div className='flex items-center justify-between border-b p-4'>
            <h3 className='font-medium'>Entrega de Conteúdo</h3>
            <Button type='text' icon={<CloseOutlined />} />
          </div>
          <div className='p-4'>{content}</div>
        </div>
      )}
    </div>
  );
};

export default Nutror;
